
import React from 'react';

export default function LocationIcon() {
  return (
    <svg id="location-icon" x="0px" y="0px" viewBox="0 0 20.8 20.8" width="24"
    height="24">
    <path className="cls-1" d="M10.4,15.8a.4.4,0,0,1-.33-.17C9.86,15.33,5,8.25,5,5.4a5.4,5.4,0,0,1,10.8,0c0,2.85-4.86,9.93-5.07,10.23A.4.4,0,0,1,10.4,15.8Zm0-15A4.6,4.6,0,0,0,5.8,5.4c0,2.21,3.5,7.63,4.6,9.29C11.5,13,15,7.61,15,5.4A4.6,4.6,0,0,0,10.4.8Z"/><path className="cls-1" d="M10.4,7.3a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,10.4,7.3Zm0-2a.6.6,0,1,0,.6.6A.6.6,0,0,0,10.4,5.3Z"/>
    <path className="cls-2" d="M15.24,12.9"/>
    <path className="cls-2" d="M5.57,12.9"/>
    <path className="cls-1" d="M10.4,20.8C4.57,20.8,0,18.87,0,16.4c0-1.68,2.05-3.13,5.48-3.89a.41.41,0,0,1,.48.3.4.4,0,0,1-.31.48C2.71,13.94.8,15.16.8,16.4c0,1.74,3.86,3.6,9.6,3.6S20,18.14,20,16.4c0-1.24-1.9-2.46-4.85-3.11a.4.4,0,0,1-.3-.48.39.39,0,0,1,.47-.3c3.43.76,5.48,2.21,5.48,3.89C20.8,18.87,16.23,20.8,10.4,20.8Z"/>
    </svg>
  );
}